import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../AuthProvider";
import { useLocation } from "react-router-dom";

const HotWaterButton = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { esp } = useContext(AuthContext);
    const active = location.pathname === "/hotwater";

    const handleClick = () => {
        navigate('/hotwater');
    };

    return (
        <button onClick={handleClick} className={active ? "controlpanel-button controlpanel-button-active" : "controlpanel-button"} disabled={!esp?.hotWater?.automationStatus}>
            <i className="bi bi-droplet controlpanel-button-icon-water" style={{ color: esp?.hotWater?.automationStatus? "#FF8C00" : "lightgrey", position: 'absolute', top: '-18%' }} />
            <span className="controlpanel-button-number" style={{position: 'absolute', top: '40%' }}>{esp?.sensorData?.hotWaterTemp?.toFixed(1)}°C</span>
            <span className="controlpanel-button-text" style={{position: 'absolute', bottom: '10%' }}>Varmvatten</span>
        </button>
    );
};

export default HotWaterButton;